<template>
<div class="full-wrapper">
  <el-scrollbar :ref="scrollbarRef">
    <div class="full">
      <el-tabs class="tab-button" v-model="subActiveTab">
        <el-tab-pane :label="tabs.application.label" :name="tabs.application.name">
          <w-application-table :table-searchable="false" :activeTab="subActiveTab" :params="params" />
        </el-tab-pane>
        <el-tab-pane :label="tabs.sql.label" :name="tabs.sql.name">
          <w-sql-table :table-searchable="false" :activeTab="subActiveTab" :params="params" />
        </el-tab-pane>
        <el-tab-pane :label="tabs.api.label" :name="tabs.api.name">
          <w-api-call-table :table-searchable="false" :activeTab="subActiveTab" :params="params" />
        </el-tab-pane>
        <el-tab-pane :label="tabs.exception.label" :name="tabs.exception.name">
          <w-service-error-table :table-searchable="false" :activeTab="subActiveTab" :params="params" />
        </el-tab-pane>
        <el-tab-pane v-if="selectedType === 'INSTANCE_TIER'" :label="tabs.alert.label" :name="tabs.alert.name">
          <w-alert-table :table-searchable="false" :activeTab="subActiveTab" :params="params" />
        </el-tab-pane>
        <!-- <el-tab-pane :label="tabs.endUser.label" :name="tabs.endUser.name">
          <w-end-user-table :objtype="selectedType" :active="active && tabs.endUser.active" :params="params" column-name="URI" />
        </el-tab-pane> -->
      </el-tabs>
    </div>
  </el-scrollbar>
  <w-scroll-top-button :visible="enableScollTop" @move-scroll-top="moveScrollTop"/>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import { camelCase, isEmpty, find } from 'lodash';
import ScrollbarMixin from '@/mixins/scrollbar';
import TabMixin from '@/mixins/apm/tab';
import WApplicationTable from '@/views/performance/node/analysis/apm/components/table/ApplicationTable';
import WSqlTable from '@/views/performance/node/analysis/apm/components/table/SqlTable';
import WApiCallTable from '@/views/performance/node/analysis/apm/components/table/ApiCallTable';
import WServiceErrorTable from '@/views/performance/node/analysis/apm/components/table/ServiceErrorTable';
import WAlertTable from '@/views/performance/node/analysis/apm/components/table/AlertTable';
import WEndUserTable from '@/views/apm/components/table/EndUserTable';

export default {
  name: 'WCommonAnalysisView',
  props: {
    active: Boolean,
    selectedType: String,
  },
  components: {
    WApplicationTable,
    WSqlTable,
    WApiCallTable,
    WServiceErrorTable,
    WAlertTable,
    WEndUserTable,
  },
  mixins: [ScrollbarMixin, TabMixin],
  data() {
    return {
      subActiveTab: null,
      tabs: {
        application: {
          name: 'application',
          label: '어플리케이션',
          active: false,
          default: true,
        },
        sql: {
          name: 'sql',
          label: 'SQL',
          active: false,
        },
        api: {
          name: 'api',
          label: 'API 호출',
          active: false,
        },
        exception: {
          name: 'exception',
          label: '트랜잭션 예외',
          active: false,
        },
        alert: {
          name: 'alert',
          label: '경보',
          active: false,
        },
        endUser: {
          name: 'endUser',
          label: '엔드유저',
          active: false,
        },
      },
    };
  },
  computed: {
    params() {
      const selectedNode = this.selectedNode;
      const analysisDateParams = this.analysisDateParams;
      const selectedType = camelCase(this.selectedType);
      const type = this.selectedType.indexOf('TIER') > -1 ? 'tier' : selectedType;
      if (!this.active) {
        return null;
      }
      return {
        selectedObjectTypeText: type,
        selectedObjectId: selectedNode[`${type}Id`],
        requestTypeText: selectedType,
        functionTypeText: 'analysis',
        startDatetime: analysisDateParams.startDatetime,
        endDatetime: analysisDateParams.endDatetime,
      };
    },
    /**
     * 기존 유지 탭이 없다면 default탭으로 현재 탭 변경
     * @return {[type]} [description]
     * @author jda
     */
    apmSubActiveTab() {
      const tabs = this.tabs;
      const currentTabName = this.$store.state.apm.subActiveTab;
      const currentTab = tabs[currentTabName];
      return isEmpty(currentTab) ? find(tabs, 'default').name : currentTab.name;
    },
    ...mapGetters(['selectedNode', 'analysisDateParams']),
  },
  watch: {
    apmSubActiveTab: {
      immediate: true,
      handler(tabName) {
        this.subActiveTab = tabName;
      },
    },
  },
  mounted() {
    this.setScrollData();
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/apm/components/CommonAnalysisView.vue